import { useEffect, useState, useRef } from 'react';

import { Alert } from '@zooplus/ui-components';

import config from '../../../../config';
import { getVersion } from '../../../services/version-service';

import usePageTracking from '@hooks/use-adobe-tracking/use-page-tracking';
import usePageVisibility from '@hooks/use-page-visibility';
import { useTranslation } from '@hooks/use-translations';

import styles from './version-checker.module.scss';

const VersionChecker = () => {
  const { t } = useTranslation();
  const [version, setVersion] = useState<string>();
  const previousVersion = useRef<string>();
  const [waitEpoch, setWaitEpoch] = useState<number>(0);
  const { isPageVisible, awayTooLong } = usePageVisibility();
  const { trackPageRefreshButtonEvent } = usePageTracking();

  const pageRefresh = () => {
    trackPageRefreshButtonEvent();
    document.location.reload();
  };

  //Every config.checkForNewVersion we check if there was a deployment
  useEffect(() => {
    const interval = setTimeout(() => {
      setWaitEpoch(waitEpoch + 1);
    }, config.checkForNewVersion * 1000);
    return () => clearTimeout(interval);
  }, [waitEpoch]);

  //if the tab goes into focus or user was away, we also check if there is a new version
  useEffect(() => {
    const loadVersion = async () => {
      const serverVersion = await getVersion();
      setVersion(serverVersion);
      if (!previousVersion.current) {
        previousVersion.current = serverVersion;
      }
    };
    if (isPageVisible === true) {
      loadVersion();
    }
  }, [isPageVisible, awayTooLong, waitEpoch]);

  if (version && previousVersion.current && version !== previousVersion.current) {
    return (
      <article className={styles.container}>
        <Alert
          buttonText={t('checkout.version.warning.refresh')}
          onButtonClick={pageRefresh}
          data-testid="version-checker">
          {t('checkout.version.warning.message')}
        </Alert>
      </article>
    );
  } else {
    return <article data-testid="no-version-checker"></article>;
  }
};

export default VersionChecker;
